export default defineNuxtRouteMiddleware((to, from) => {
  const [, toSlug] = to.path.split('/')
  const [, fromSlug] = from.path.split('/')
  const { isHydrating } = useNuxtApp()

  if (!isHydrating && toSlug === fromSlug) return

  const { activeUrlParams, normalizedParams, setUrlParams } =
    useUrlParamsState()

  if (!activeUrlParams.analyticsView) {
    setUrlParams('analyticsView', 'true')
  }

  const defaultInsightMode = 'Active|Observation'

  if (!to.query.insight_mode) {
    setUrlParams('insight_mode', defaultInsightMode)
  } else {
    const validInsightModes = normalizedParams.value?.insight_mode?.filter(
      (item: string) =>
        ['Active', 'Observation', 'Inactive', 'scheduled_all'].includes(item),
    )

    if (validInsightModes?.length) {
      setUrlParams('insight_mode', validInsightModes)
    } else {
      setUrlParams('insight_mode', defaultInsightMode)
    }
  }
})
